import * as React from 'react';
import { useEffect, useState } from 'react';
import { ApplicationState } from "../../redux/reducers";
import { connect } from "react-redux"
import { saveMercancias } from "../../redux/actions/mercanciaActions";
import { setSolicitud, setSolicitudCopia } from "../../redux/actions/solicitudActions";
import MercanciaLista from "./mercanciaLista";
import NumberField from "../controls/NumberField";
import { IEvent } from "../../interfaces/IEvent";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import { enums } from "../../enums/enums";
import { useSnackbar } from 'notistack';
import { IParametro } from "../../redux/types/parametroActionTypes";
import * as utility from "../../blocks/utility";
import { ICatalogo } from "../../entities/catalogos/ICatalogo";
import NumberFormat from "react-number-format";
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import SubmitButton from "../controls/SubmitButton";
import { ICliente } from '../../entities/catalogos/ICliente';
import { Mercancia } from '../../entities/solicitudes/Mercancia';
import { Solicitud } from '../../entities/solicitudes/Solicitud';
import { IUsuario } from '../../entities/catalogos/IUsuario';
import { loadEmbalajes } from '../../redux/actions/embalajeActions';
import swal from 'sweetalert2';
import Help, { IHelp } from '../help/Help';
import { Dialog, Accordion, AccordionDetails, AccordionSummary, Box, Button, createStyles, Grid, makeStyles, TextField, Theme, Typography } from '@material-ui/core';
import { Add } from '@material-ui/icons';
import MercanciaDatosComplementariosLista from './mercanciaDatosComplementariosLista';
import { MercanciaDatosComplementarios } from '../../entities/solicitudes/MercanciaDatosComplementarios';
import { saveMercanciasDatosComplementarios } from '../../redux/actions/mercanciaDatosComplementariosActions';
import { loadClavesUnidad } from '../../redux/actions/claveUnidadActions';
import { loadClavesProducto } from '../../redux/actions/claveProductoActions';
import { loadClaveFraccionArancelaria } from '../../redux/actions/claveFraccionArancelariaActions';
import Referencias from '../solicitud/Referencias';
import useCommonApi from "../../api/useCommonApi";
import LoadingDialog from "../controls/LoadingDialog";
import { traducirButton, traducirLabel, traducirMessage } from  '../../blocks/traductor';



const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: '100%',
            boxShadow: "none"
        },
        principal: {
            height: '100%',
            backgroundColor: "#fff",
            padding: "10px"
        },

        icon: {
            width: "40px",
            height: "40px",
            minWidth: "40px",
            borderRadius: "20px",
            backgroundColor: "#19754e",
            color: "#fff",
            textAlign: "center",
            paddingTop: "5px"
        },
        title: {
            fontSize: "24px",
            paddingBottom: "20px"
        },
        heading: {
            fontSize: "0.875rem",
            color: "#00653b",
            fontWeight: theme.typography.fontWeightBold,
            borderBottom: "2px solid #00653b"
        },
        headingAdicional: {
            fontSize: theme.typography.pxToRem(20),
            fontWeight: theme.typography.fontWeightBold,
            textAlign: "center"
        },

    }),
);

interface OwnProps {
    siguienteSeccion: (estatusId: number, cotizacionCopia: Solicitud) => void
    cotizacionId: number
}

interface StateProps {
    cliente: ICliente
    mercancias: Mercancia[]
    mercanciasDatosComplementarios: MercanciaDatosComplementarios[]
    solicitud: Solicitud
    solicitudCopia: Solicitud
    parametros: IParametro[]
    tiposSeguroObservacion: ICatalogo[]
    usuario: IUsuario
    ayuda: IHelp
}

interface DispatchProps {
    saveMercancias: typeof saveMercancias
    saveMercanciasDatosComplmentarios: typeof saveMercanciasDatosComplementarios
    setSolicitud: typeof setSolicitud
    setSolicitudCopia: typeof setSolicitudCopia
    loadEmbalajes: typeof loadEmbalajes
    loadClavesUnidad: typeof loadClavesUnidad
    loadClavesProducto: typeof loadClavesProducto
    loadClaveFraccionArancelaria: typeof loadClaveFraccionArancelaria
}

interface ISeguroInfo {
    id: number
    titulo: string
}

let segurosInfo: ISeguroInfo[] = [{ id: 1, titulo: traducirLabel(273) }, { id: 2, titulo: traducirLabel(274) }];

type Props = OwnProps & StateProps & DispatchProps

const DatosMercancia = ({
    cliente, mercancias, mercanciasDatosComplementarios, siguienteSeccion, saveMercancias, saveMercanciasDatosComplmentarios, solicitud, setSolicitud, solicitudCopia,
    setSolicitudCopia, parametros, tiposSeguroObservacion, loadEmbalajes, ayuda, loadClavesUnidad, loadClavesProducto, loadClaveFraccionArancelaria
}: Props) => {
    const seccionCompletada = solicitudCopia.estatusId > enums.estatusSolicitud.datosMercancia;
    const apiSource = useCommonApi();
    const { enqueueSnackbar } = useSnackbar();
    const [seguroInfo, setSeguroInfo] = useState<ISeguroInfo | undefined>({ id: 0, titulo: "" });
    const [dialogOpen, setDialogOpen] = useState(false);

    const valorSeguroBasico = utility.getValorParametro(parametros, "seguroBasicoCobro", 2);
    const coberturaSeguroBasico = utility.getValorParametro(parametros, "seguroBasicoCubre");
    const seguroDeclaradoMinimo = utility.getValorParametro(parametros, "seguroDeclaradoMinimo");
    const seguroDeclaradoMaximo = utility.getValorParametro(parametros, "seguroDeclaradoMaximo");
    const [descripcionContenido, setDescripcionContenido] = useState(solicitudCopia.descripcionMercancia);
    const descripcionContenidoShow = solicitudCopia.tipoSolicitud === "cotizacion" ? { display: "none" } : { display: "inherit" };
    const [expanded, setExpanded] = useState<string | false>('DetalleMercancia');
    const [datosComplemtariosHabilitado, setDatosComplemtariosHabilitado] = useState(seccionCompletada);
    const [descripcionContenidoHabilitado, setDescripcionContenidoHabilitado] = useState(seccionCompletada);
    const [seguroHabilitado, setSeguroHabilitado] = useState(seccionCompletada);
    const [referenciasHabilitado, setReferecniasHabilitado] = useState(seccionCompletada);
    const [showLoading, setLoading] = useState(false);
    const classes = useStyles();
    const getClasificacionOrigen = localStorage.getItem('ClasificacionAreaServicioOrigen');
    const getClasificacionDestino = localStorage.getItem('ClasificacionAreaServicioDestino');
    const getCartaPorte = localStorage.getItem("CartaPorte");
    
    const detalleMercanciaShow = (getClasificacionOrigen === '4' || getClasificacionOrigen === '5' || getClasificacionDestino === '4' || getClasificacionDestino === '5' || getCartaPorte === "true") || (cliente.clienteConfiguracionComplementoCartaPorte !== null && cliente.clienteConfiguracionComplementoCartaPorte.activo);

    //const detalleMercanciaShow = cliente.clienteConfiguracionComplementoCartaPorte === null ? false : cliente.clienteConfiguracionComplementoCartaPorte.activo;
    const detalleMercanciaShowObliga = cliente.clienteConfiguracionCompCartaPorteDetalle === null ? false : cliente.clienteConfiguracionCompCartaPorteDetalle.activo;

    useEffect(() => {
        ValidatorForm.addValidationRule('requiredIf', (value) => {
            return !(solicitudCopia.esSeguroMercancia && (isNaN(value) || value === null));
        });

        return function cleanup() {
            ValidatorForm.removeValidationRule('requiredIf');
        }
    }, [solicitudCopia]);

    React.useEffect(() => {
        loadEmbalajes();
        handleSeguro(solicitudCopia.esSeguroBasico, true);
    }, []);

    const siguienteTab = async (mercancias: Mercancia[]) => {
        // if (cliente.esClase && solicitudCopia.claseId === 0) {
        //     let mensaje = traducirMessage(119);
        //     enqueueSnackbar(mensaje, { variant: "error" });
        //     return;
        // }

        setLoading(true);
        const clienteTieneParidad = await apiSource.obtenerAsync<any>(`/cliente/${cliente.id}/has-paridad`);

        if (!clienteTieneParidad) {
            const mensaje = traducirMessage(200) //"No se encuentra un tipo de cambio definido, favor de verificar";
            swal.fire({
                titleText: traducirMessage(11), //!Aviso!, 
                text: mensaje, type: 'warning'
            });
            setLoading(false);
            return;
        }
        if (solicitudCopia.tipoSolicitud !== 'cotizacion') {
            const valorMinimoObject = parametros?.find(a => a.nombre === 'Valor mínimo peso unitario');
            if (valorMinimoObject !== undefined && valorMinimoObject !== null)
            {
                let valorMinimoArray = valorMinimoObject["valor"].split('|');
                let pesoMinimo = 0;
                if (solicitudCopia.unidadMedidaPesoId === enums.unidadMedidaPeso.kilos)
                    pesoMinimo = parseFloat(valorMinimoArray[0]);
                else
                    pesoMinimo = parseFloat(valorMinimoArray[1]);

                let mensaje = traducirMessage(284) + pesoMinimo.toString();

                let errorPeso=false;
                mercancias.forEach(a=> {
                    if((a?.peso??0) < pesoMinimo)
                    {
                        errorPeso=true;
                    }
                })

                if (errorPeso) {
                    swal.fire({
                        titleText: traducirMessage(11), // '¡Aviso!',
                        text: mensaje, // "EL PESO MÍNIMO UNITARIO ES DE .",
                        type: 'warning',
                    });
                    setLoading(false);
                    return
                }
            }
        }



        setLoading(false);
        if (solicitudCopia.tipoSolicitud === 'cotizacion') {
            setExpanded("Seguro");
        } else {
            setExpanded("DetalleMercanciaComplementaria");
            setDatosComplemtariosHabilitado(true);
        }

        saveMercancias(mercancias);

        if (cliente.esExcluirSeguro) {
            setSeguroHabilitado(false);
        }

        let copiaSolicitud = new Solicitud({ ...solicitud, estatusId: enums.estatusSolicitud.datosMercancia });
        setSolicitud(copiaSolicitud);

        copiaSolicitud = new Solicitud({ ...solicitudCopia, estatusId: enums.estatusSolicitud.datosMercancia });
        setSolicitudCopia(copiaSolicitud);
        const getClasificacionOrigen = localStorage.getItem('ClasificacionAreaServicioOrigen');
        const getClasificacionDestino = localStorage.getItem('ClasificacionAreaServicioDestino');
        if(cliente.clienteConfiguracionComplementoCartaPorte !== null){
            if(cliente.clienteConfiguracionComplementoCartaPorte.activo && solicitudCopia.tipoSolicitud !== 'cotizacion'){
                setDatosComplemtariosHabilitado(true);
            }

            if(!cliente.clienteConfiguracionComplementoCartaPorte.activo && solicitudCopia.tipoSolicitud !== 'cotizacion' && getClasificacionOrigen === "4" ||
               !cliente.clienteConfiguracionComplementoCartaPorte.activo && solicitudCopia.tipoSolicitud !== 'cotizacion' && getClasificacionOrigen === "5" ||
               !cliente.clienteConfiguracionComplementoCartaPorte.activo && solicitudCopia.tipoSolicitud !== 'cotizacion' && getClasificacionDestino === "4" ||
               !cliente.clienteConfiguracionComplementoCartaPorte.activo && solicitudCopia.tipoSolicitud !== 'cotizacion' && getClasificacionDestino === "5"){
                setDatosComplemtariosHabilitado(true);
            } else {
                if(!cliente.clienteConfiguracionComplementoCartaPorte.activo && solicitudCopia.tipoSolicitud !== 'cotizacion'){
                    localStorage.removeItem("mercanciasDatos");
                    setExpanded("DescripcionContenido");
                    setDatosComplemtariosHabilitado(false);
                    setDescripcionContenidoHabilitado(true);
                }
            }

        }
        else{
            if(solicitudCopia.tipoSolicitud !== 'cotizacion'){
                localStorage.removeItem("mercanciasDatos");
                setExpanded("DescripcionContenido");
                setDatosComplemtariosHabilitado(false);
                setDescripcionContenidoHabilitado(true);
            }
        }
    };
    const siguienteTabDatosComplmentarios = (mercanciasDatosComplementarios: MercanciaDatosComplementarios[]) => {
        setExpanded("DescripcionContenido");
        saveMercanciasDatosComplmentarios(mercanciasDatosComplementarios);

        setDescripcionContenidoHabilitado(true);
    };

    const siguienteTabSeguro = () => {
        if (!descripcionContenido) {
            let mensaje = traducirMessage(107); // 'Favor de proporcionar la descripción del contenido.';
            enqueueSnackbar(mensaje, { variant: "error" });
            return;
        }
        setExpanded("Seguro");

        const copiaSolicitud = new Solicitud({
            ...solicitudCopia, descripcionMercancia: descripcionContenido,
            estatusId: enums.estatusSolicitud.datosMercancia
        });
        setSolicitudCopia(copiaSolicitud);

        if (cliente.esExcluirSeguro) {
            setSeguroHabilitado(false);
            setReferecniasHabilitado(true);
        }

        setSeguroHabilitado(true);
    };

    const handleSeguro = (esBasico: boolean, esInicial: boolean) => {

        const valorMercancia = esBasico ? null : solicitudCopia.valorMercancia || undefined;
        const copiaSolicitud = new Solicitud({ ...solicitudCopia, valorMercancia });
        copiaSolicitud.SetSeguro(esBasico, cliente.esExcluirSeguro);


        if (!esBasico) {
            copiaSolicitud.esSeguroMercancia = true;
            copiaSolicitud.esSeguroBasico = false;
        }
        if (esBasico) {
            copiaSolicitud.esSeguroMercancia = false;
            copiaSolicitud.esSeguroBasico = true;
        }

        if (esInicial && cliente.esExcluirSeguro) {
            copiaSolicitud.esSeguroMercancia = false;
            copiaSolicitud.esSeguroBasico = false;
        }


        if (copiaSolicitud.esSeguroBasico || copiaSolicitud.esSeguroMercancia) {
            if (cliente.esExcluirSeguro) {
                let mensaje = traducirLabel(39); // 'Cliente ha solicitado excluir seguro.';
                enqueueSnackbar(mensaje, { variant: "warning" });
            }
        }
        setSolicitudCopia(copiaSolicitud);
    };

    const handleSeguroCheck = (esBasico: boolean) => {
        const valorMercancia = esBasico ? null : solicitudCopia.valorMercancia || undefined;
        const copiaSolicitud = new Solicitud({ ...solicitudCopia, valorMercancia });

        if (!esBasico) {
            copiaSolicitud.esSeguroMercancia = !(copiaSolicitud.esSeguroMercancia);
            if (copiaSolicitud.esSeguroMercancia) {
                const mensaje = traducirMessage(218); //"PARA HACER VALIDO ESTE SEGURO, DEBERÁ PROPORCIONAR LA COPIA DE LA FACTURA COMERCIAL DEL MATERIAL.";
                swal.fire({ titleText: traducirMessage(11), text: mensaje, type: 'warning' });

                copiaSolicitud.esSeguroBasico = false;
            }
        }
        if (esBasico) {
            copiaSolicitud.esSeguroBasico = !(copiaSolicitud.esSeguroBasico);
            if (copiaSolicitud.esSeguroBasico)
                copiaSolicitud.esSeguroMercancia = false;
        }

        if (copiaSolicitud.esSeguroBasico || copiaSolicitud.esSeguroMercancia) {
            if (cliente.esExcluirSeguro) {
                let mensaje = traducirLabel(39); //'Cliente ha solicitado excluir seguro.';
                enqueueSnackbar(mensaje, { variant: "warning" });
            }
        }
        setSolicitudCopia(copiaSolicitud);
    }

    const setValorMercancia = (event: IEvent) => {
        const nuevaCotizacion = new Solicitud({ ...solicitudCopia, valorMercancia: Number(event.target.value) });
        setSolicitudCopia(nuevaCotizacion);
    };

    const openDialog = (id: number) => {
        const seguro = segurosInfo.find(s => s.id === id);
        if(id===1){
            setSeguroInfo({id:1, titulo:traducirLabel(273)});
        }
        else{
            if(id===2){
                setSeguroInfo({id: 2, titulo: traducirLabel(274)});
            }
            else{
                setSeguroInfo({id: 0, titulo: ""});
            }
        }
        //setSeguroInfo(seguro);
        setDialogOpen(true);
    };

    const closeDialog = () => {
        setDialogOpen(false);
    };

    const handleSiguienteSeccion = () => {
        const nuevaCotizacion = new Solicitud(solicitudCopia);
        nuevaCotizacion.ValidarValorMercancia(seguroDeclaradoMinimo, seguroDeclaradoMaximo, cliente.esExcluirSeguro);

        setSolicitudCopia(nuevaCotizacion);

        if (nuevaCotizacion.esFormaValida) {

            if (solicitudCopia.tipoSolicitud == 'cotizacion') {
                siguienteSeccion(enums.estatusSolicitud.serviciosAdicionales, nuevaCotizacion);
            }
            else {
                setReferecniasHabilitado(true);
                setExpanded("Referencias");
            }

        } else if (nuevaCotizacion.valorMercancia != null) {
            let mensaje = nuevaCotizacion.valorMercancia < seguroDeclaradoMinimo ?
                traducirMessage(58).replace('#####', `$ ${seguroDeclaradoMinimo}`)
                //El Importe mínimo para declarar es de $${seguroDeclaradoMinimo}, si la suma asegurada es menor, favor de utilizar seguro básico.`
                : traducirMessage(57).replace('#####', `$ ${seguroDeclaradoMaximo}`)
            //`El Importe máximo permitido para asegurar es de $${seguroDeclaradoMaximo}, si la cantidad requerida es mayor, favor de contactar al área de Reclamaciones.`;

            swal.fire({
                titleText: traducirMessage(11), // ¡Aviso!
                text: mensaje,
                type: 'warning',
            });
        }
        else if (!nuevaCotizacion.esSeguroBasico) {
            let mensaje="";
            if (solicitudCopia.tipoSolicitud === 'cotizacion') {
                mensaje = traducirMessage(25) //"¿DESEA CREAR LA COTIZACIÓN SIN SEGURO?",
            }
            else{
                mensaje = traducirMessage(287) //"¿DESEA CREAR LA SOLICITUD DE SERVICIO SIN SEGURO?",
            }
            swal.fire({
                titleText: traducirLabel(48), //'Confirmar Seguro',
                text: mensaje,
                type: 'warning',
                showConfirmButton: true,
                showCancelButton: true,

                cancelButtonAriaLabel: traducirButton(6), // 'CANCELAR',
                confirmButtonAriaLabel: traducirButton(17), // 'ACEPTAR'
            
            }).then((result) => {
                if (result.value == true) {
                    if (solicitudCopia.tipoSolicitud == 'cotizacion') {
                        siguienteSeccion(enums.estatusSolicitud.serviciosAdicionales, nuevaCotizacion);
                    }
                    else {
                        setReferecniasHabilitado(true);
                        setExpanded("Referencias");
                    }
                }
            })


            // let mensaje = 'Debe de seleccionar un seguro.';
            // enqueueSnackbar(mensaje, { variant: "error" });
        }
    };

    const handleChangePanel = (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
        setExpanded(isExpanded ? panel : false);
    };

    const getReferencias = (referencias: any) => {
        if (!solicitudCopia.distribuidorRemitente || !solicitudCopia.contactoOrigen) {
            let mensaje = traducirMessage(96); // `Favor de capturar los datos faltantes en la sección Origen y Destino.`;
            enqueueSnackbar(mensaje, { variant: "error" });
            return;
        }

        const copiaSolicitud = new Solicitud(solicitudCopia);
        copiaSolicitud.clienteReferencias = referencias;

        setSolicitudCopia(copiaSolicitud);
        siguienteSeccion(enums.estatusSolicitud.serviciosAdicionales, copiaSolicitud);
    }

    return (<>
        <Accordion expanded={expanded === 'DetalleMercancia'} onChange={handleChangePanel('DetalleMercancia')}>
            <AccordionSummary
                expandIcon={<Add />}
                aria-controls="panel1a-content"
                id="panel1a-header"
            >
                <Typography className={classes.heading}>
                    {/* DETALLE DE MERCANCÍA */
                        traducirLabel(88)}
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container spacing={1} >
                    <Grid item sm={12}>
                        <div>
                            <Box>
                                <Help comments={traducirMessage(38)}customStyle={{ top: "-30px", right: "-20px" }} />
                            </Box>
                            <Box mb={3} className="title text-center">
                                {/* ¿Cómo es la mercancía que desea enviar? */
                                    traducirMessage(18)}
                            </Box>
                            <MercanciaLista value={mercancias} siguienteTab={siguienteTab} />
                        </div>
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
        {detalleMercanciaShow &&
        <Accordion expanded={expanded === 'DetalleMercanciaComplementaria'}
            onChange={handleChangePanel('DetalleMercanciaComplementaria')}
            style={descripcionContenidoShow}>
            <AccordionSummary
                disabled={!datosComplemtariosHabilitado}
                expandIcon={<Add />}
                aria-controls="panel1a-content"
                id="panel1a-header">
                <Typography className={classes.heading}>
                    {/* DETALLE DE MERCANCÍA DE DATOS COMPLEMENTARIOS */
                        traducirLabel(89)}
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container spacing={1} >
                    <Grid item sm={12}>
                        <div>
                            <Box>
                                <Help comments={traducirMessage(41)} customStyle={{ top: "-30px", right: "-20px" }} />
                            </Box>
                            <div style={{ paddingTop: "20px" }}>
                                <MercanciaDatosComplementariosLista value={mercanciasDatosComplementarios} siguienteTab={siguienteTabDatosComplmentarios} />
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
        }
        <Accordion expanded={expanded === 'DescripcionContenido'} onChange={handleChangePanel('DescripcionContenido')}
            style={descripcionContenidoShow} >
            <AccordionSummary disabled={!descripcionContenidoHabilitado}
                expandIcon={<Add />}
                aria-controls="panel2a-content"
                id="panel2a-header"
            >
                <Typography className={classes.heading}>
                    {/* DESCRIPCIÓN DE CONTENIDO */
                        traducirLabel(83)}
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container spacing={1} >
                    <Grid item sm={12}>
                        <Grid container spacing={2} alignItems="center">
                            {/* <Grid item xs={12}>
                        <Help comments="DatosAdicionales" ayuda={props.ayuda} customStyle={{ top: "-10px",right: "-15px" }} />
                    </Grid> */}
                            <Grid item sm={12}>
                                <Box mb={3} className="title text-center">
                                    {/* Descripción contenido */
                                        traducirLabel(83)}
                                </Box>
                            </Grid>
                            <Grid item sm={12}>
                                <TextField fullWidth
                                    id="standard-textarea"
                                    variant="outlined"
                                    required={true}
                                    title={traducirMessage(298)}
                                    onChange={e => setDescripcionContenido(e.target.value)}
                                    rows={10} value={descripcionContenido}
                                    multiline
                                    inputProps={{ maxLength: 250 }}
                                />
                                <Typography
                                    variant="body2"
                                    style={{
                                        color: (descripcionContenido?.length || 0) >= 250 ? 'red' : '#333',
                                        fontWeight: 'bold',
                                        display: 'block',
                                        textAlign: 'right',
                                        marginTop: '4px'
                                    }}
                                >
                                    {descripcionContenido?.length || 0} / 250
                                </Typography>
                            </Grid>
                            <Grid item sm={12} style={{ textAlign: "end" }}>
                                <Button variant="contained" color="primary" onClick={siguienteTabSeguro} >
                                    {/* Siguiente */
                                        traducirButton(15)}
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
        <Accordion expanded={expanded === 'Seguro'} onChange={handleChangePanel('Seguro')}>
            <AccordionSummary disabled={!seguroHabilitado}
                expandIcon={<Add />}
                aria-controls="panel2a-content"
                id="panel2a-header">
                <Typography className={classes.heading}>
                    {/* SEGURO */
                        traducirLabel(272)}
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container spacing={1} >
                    <Grid item sm={12}>
                        <Box>
                            <Help comments={traducirMessage(93)} customStyle={{ top: "-30px", right: "-20px" }} />
                        </Box>
                        <Box mb={3} className="title text-center">
                            {/* ¿Desea asegurar su mercancía? */
                                traducirMessage(22)}
                        </Box>

                        <ValidatorForm onSubmit={handleSiguienteSeccion}>
                            <Grid container spacing={3} justify="center">
                                <Grid item>
                                    <Box
                                        className={`pointer card medium-height ${solicitudCopia.esSeguroBasico ? 'selected' : ''}`}
                                        style={{ padding: "10px 20px", width: "180px", height: "200px" }}
                                        display="flex" flexDirection="column">
                                        <Box className="title-2 green-label text-center" onClick={() => handleSeguroCheck(true)}>
                                            <b>
                                                {/* Seguro Básico */
                                                    traducirLabel(273)}
                                            </b>
                                        </Box>

                                        <Box className="title-4" py={1} onClick={() => handleSeguroCheck(true)}>
                                            {/* Cobertura máxima de hasta */
                                                traducirLabel(40).split('#####')[0]}
                                            <NumberFormat value={coberturaSeguroBasico} displayType={'text'} prefix={'$'}
                                                thousandSeparator={true} style={{ padding: '0 4px' }} />
                                            {/* mn por guía */
                                                traducirLabel(40).split('#####')[1]}
                                        </Box>

                                        <Box display="flex" className="title-4" flexGrow={1} onClick={() => handleSeguroCheck(true)}>
                                            <Box py={1} flexGrow={1}>
                                                {/* Costo Adicional */
                                                    traducirLabel(57)}
                                            </Box>
                                            <Box py={1}>
                                                <b>${valorSeguroBasico}</b>
                                            </Box>
                                        </Box>

                                        <Box className="title-4" pt={1}>
                                            <Button color="primary" size="small" className="link-sm title-4"
                                                onClick={() => openDialog(enums.seguro.basico)}>
                                                {/* Ver políticas */
                                                    traducirLabel(317)}
                                            </Button>
                                        </Box>
                                    </Box>
                                </Grid>

                                <Grid item>
                                    <Box
                                        className={`pointer card medium-height ${solicitudCopia.esSeguroMercancia ? 'selected' : ''}`}
                                        style={{ padding: "10px 20px", width: "180px", height: "200px" }}
                                        display="flex" flexDirection="column">
                                        <Box className="title-2 green-label text-center" onClick={() => handleSeguroCheck(false)}>
                                            <b>
                                                {/* Seguro Declarado */
                                                    traducirLabel(274)}
                                            </b>
                                        </Box>

                                        <Box className="title-4" py={1} onClick={() => handleSeguroCheck(false)}>
                                            {/* Cobertura máxima de hasta */
                                                traducirLabel(40).split('#####')[0]}
                                            <NumberFormat value={seguroDeclaradoMaximo} displayType={'text'} prefix={'$'}
                                                thousandSeparator={true} style={{ padding: '0 4px' }} />
                                            {/* mn por guía */
                                                traducirLabel(40).split('#####')[1]}
                                        </Box>

                                        <Box className="title-4" pt={1} onClick={() => handleSeguroCheck(false)}>
                                            <b>
                                                {/* Valor Mercancía */
                                                    traducirLabel(314)}
                                            </b>
                                        </Box>

                                        <Box className="title-4" flexGrow={1}><TextValidator
                                            value={solicitudCopia?.valorMercancia}
                                            name="valorMercancia"
                                            onChange={setValorMercancia}
                                            fullWidth
                                            validators={['requiredIf']}
                                            errorMessages={[traducirMessage(299)]}
                                            disabled={!solicitudCopia.esSeguroMercancia}
                                            InputProps={{
                                                inputComponent: NumberField,
                                                inputProps: { prefix: "$", precision: 2, maxLength: 8 },
                                            }}
                                        />
                                        </Box>

                                        <Box className="title-4" pt={1}>
                                            <Button color="primary" size="small" className="link-sm title-4"
                                                onClick={() => openDialog(enums.seguro.declarado)}>
                                                {/* Ver políticas */
                                                    traducirLabel(317)}
                                            </Button>
                                        </Box>
                                    </Box>
                                </Grid>
                            </Grid>

                            <SubmitButton />
                        </ValidatorForm>
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
        {solicitudCopia.tipoSolicitud != 'cotizacion' &&
            <Accordion expanded={expanded === 'Referencias'} onChange={handleChangePanel('Referencias')}>
                <AccordionSummary
                    expandIcon={<Add />}
                    aria-controls="panel1a-content"
                    disabled={!referenciasHabilitado}
                    id="panel1a-header">
                    <Typography className={classes.heading}>
                        {/* REFERENCIAS */
                            traducirLabel(260)}
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container spacing={1} >
                        <Grid item sm={12}>
                            <Box>
                                <Help comments={traducirMessage(35)} customStyle={{ bottom: "10px", right: "-15px" }} />
                            </Box>
                            <Box mb={3} className="title text-center">
                                {/* ¿Desea agregar referencias? */
                                    traducirMessage(21)}
                            </Box>

                            <Grid container spacing={3} justify="center">
                                <Referencias setReferencias={getReferencias} referencias={solicitudCopia.clienteReferencias} />
                            </Grid>
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>
        }

        <Dialog open={dialogOpen} maxWidth="md" fullWidth={true}>
            <DialogTitle id="simple-dialog-title">{seguroInfo?.titulo}</DialogTitle>
            <DialogContent dividers>
                {localStorage.getItem("idioma") === 'en-US' &&
                    <DialogContentText>
                        {tiposSeguroObservacion.map((ts) => (
                            ts.id === seguroInfo?.id && ts.etiquetaTipoSeguroObservacion.nombre !== '' &&
                            <Box mb={1}>{ts.etiquetaTipoSeguroObservacion.nombre}</Box>
                        ))}
                    </DialogContentText>
                }
                {localStorage.getItem("idioma") !== 'en-US' &&
                    <DialogContentText>
                        {tiposSeguroObservacion.map((ts) => (
                            ts.id === seguroInfo?.id && ts.nombre !== '' &&
                            <Box mb={1}>{ts.nombre}</Box>
                        ))}
                    </DialogContentText>
                }
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={closeDialog} color="primary">
                    {/* Cerrar */
                        traducirButton(16)}
                </Button>
            </DialogActions>
        </Dialog>

        {showLoading &&
            // Procesando
            <> <LoadingDialog titulo={traducirLabel(240)} abierto={true} /></>
        }
    </>)
};
const mapStateToProps = (state: ApplicationState) => ({
    cliente: state.cliente,
    mercancias: state.mercancias,
    mercanciasDatosComplementarios: state.mercanciasDatosComplementarios,
    solicitud: state.solicitud,
    solicitudCopia: state.solicitudCopia,
    parametros: state.parametros,
    tiposSeguroObservacion: state.tiposSeguroObservacion,
    usuario: state.usuario,
    ayuda: state.ayuda
});

const mapDispatchToProps = {
    saveMercancias: saveMercancias,
    saveMercanciasDatosComplmentarios: saveMercanciasDatosComplementarios,
    setSolicitud: setSolicitud,
    setSolicitudCopia: setSolicitudCopia,
    loadEmbalajes: loadEmbalajes,
    loadClavesUnidad: loadClavesUnidad,
    loadClavesProducto: loadClavesProducto,
    loadClaveFraccionArancelaria: loadClaveFraccionArancelaria

};

export default connect(mapStateToProps, mapDispatchToProps)(DatosMercancia);
